import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type Props = {
  withFilters?: boolean
  isDragging?: boolean
  onUpload?: () => void
}

const DocumentsDataTableEmptyState = ({
  withFilters = false,
  isDragging = false,
  onUpload,
}: Props) => {
  return (
    <>
      {withFilters && (
        <>
          <Box flexDirection="column" gap="s16" alignItems="center">
            <Icon.Large icon="document-folder-files" color="grey600" />
            <Box flexDirection="column" gap="s4" alignItems="center">
              <Text.Header2>
                {i18n.t('documents.documents_datatable.empty_state.with_filters.title')}
              </Text.Header2>
              <Text.Normal>
                {i18n.t('documents.documents_datatable.empty_state.with_filters.description')}
              </Text.Normal>
            </Box>
          </Box>
        </>
      )}
      {!withFilters && (
        <>
          <Box flexDirection="column" gap="s16" alignItems="center">
            <Icon.Large icon="file-error" color="grey600" />
            <Box flexDirection="column" gap="s4" alignItems="center">
              <Text.Header2>
                {isDragging
                  ? i18n.t(
                      'documents.documents_datatable.empty_state.blank_state.with_dragging_title'
                    )
                  : i18n.t('documents.documents_datatable.empty_state.blank_state.title')}
              </Text.Header2>
              <Text.Normal>
                {onUpload
                  ? i18n.t(
                      'documents.documents_datatable.empty_state.blank_state.with_upload_description'
                    )
                  : i18n.t(
                      'documents.documents_datatable.empty_state.blank_state.without_upload_description'
                    )}
              </Text.Normal>
            </Box>
            {onUpload && (
              <Button type="secondary" onClick={onUpload} iconName="upload">
                {i18n.t('documents.documents_datatable.empty_state.blank_state.upload')}
              </Button>
            )}
          </Box>
        </>
      )}
    </>
  )
}

export default DocumentsDataTableEmptyState
